module.exports = __webpack_public_path__ + "static/media/_DSC6506_cropped.eca150b8.jpg";